import { get, set } from '../lib/storage'
import { decodeURLParams } from "../lib/utils";
import moment from 'moment'

const urlParams = decodeURLParams();
let dater = get('hotel.dater', true) || {
    startDate: moment().add(3, 'days').startOf('d').format('YYYY-MM-DD'),
    endDate: moment().add(4, 'days').startOf('d').format('YYYY-MM-DD')
}
let guests = get('guests', true) || {
    room: 1,
    Adults: 2,
    Children: 0,
    Cots: 0,
    Age: []
}

//url中存在日期等信息
if (urlParams.startdate) {
    dater.startDate = urlParams.startdate
    dater.endDate = urlParams.enddate
    guests.room = urlParams.room * 1
}

const hotel = {
    state: {
        guests: guests,
        dater: dater,
        destination: get('hotel.des', true) || {
            city_code: '',
            name: ''
        }
    },
    mutations: {
        SET_GUESTS: (state, data) => {
            state.guests = data
        },
        SET_DATER: (state, data) => {
            state.dater.startDate = data.startDate
            state.dater.endDate = data.endDate
            set('hotel.dater', data);
        },
        SET_DESTINATION: (state, data) => {
            // state.destination.city_code = data.cityCode || data.city_code;
            // state.destination.name = data.hotelName || data.areaName || data.cityName || data.city_name || data.name;
            // state.destination.lng = data.longitude;
            // state.destination.lat = data.latitude;
            // state.destination.hotelItemCode = data.hotelItemCode
            // state.destination.searchType = data.searchType
            state.destination = data;
            state.destination.name = data.hotelName || data.areaName || data.cityName;
            set('hotel.des', state.destination);
        }
    },
    actions: {
        updateGuests({ commit }, data) {
            set('guests', data)
            commit('SET_GUESTS', data);
        },
        searchHotelData({ commit }, data) {
            commit('SET_DATER', data.dater);
            commit('SET_DESTINATION', data.des);
        }
    }
}

export default hotel


// WEBPACK FOOTER //
// ./src/store/hotel.js